<gc-text [variant]="'paragraphHeading'">{{
  'signingSummary.selfInspections' | translate
}}</gc-text>
<div class="self-inspections">
  @for (
    selfInspection of selfInspectionData();
    track selfInspection.definition.id
  ) {
    <div class="self-inspection">
      <gc-text [variant]="'largeParagraphBold'">{{
        selfInspection.definition.label
      }}</gc-text>
      <gc-text [variant]="'largeParagraph'">
        {{
          selfInspection.definition.translations[language()]?.text ??
            selfInspection.definition.translations['en']?.text
        }}
      </gc-text>
      @if (selfInspection.answer.isNotCompletableComment) {
        <div class="not-applicable">
          <gc-text [variant]="'informationBold'">{{
            'signingSummary.notApplicable' | translate
          }}</gc-text>
          <gc-text [variant]="'information'">{{
            selfInspection.answer.isNotCompletableComment
          }}</gc-text>
        </div>
      }
      @if (selfInspection.answer.attachments.length) {
        @for (
          attachment of attachments()[selfInspection.definition.id];
          track attachment;
          let index = $index
        ) {
          @if (attachment) {
            <app-protected-img
              [url]="attachment"
              [alt]="selfInspection.answer.attachments[index].fileName"
              class="img"
            />
          }
        }
      }
    </div>
  }
</div>
